export default{
    getActiveModalData:(state) => {
        return state.activeModalData
    }
}